import * as ActionTypes from '../constants/actionTypes';

export const load_product = (product_type = 'maytapi') => ({
	type: ActionTypes.PRODUCT_REQUESTED,
	product_type,
});
